import { useEffect, useState } from "react";

export default function FloatingBar() {
  const [show, setShow] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const p = max > 0 ? Math.min(100, Math.round((window.scrollY / max) * 100)) : 0;
      setProgress(p);
      setShow(window.scrollY > 640);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3 transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "pointer-events-none opacity-0 translate-y-4"
      }`}
    >
      <a
        href="#about"
        aria-label="前往我要爆料"
        className="flex h-11 w-11 items-center justify-center rounded-full border border-primary-300 bg-background-50 text-primary-700 transition-colors hover:bg-primary-50 cursor-pointer"
      >
        <i className="ri-message-3-line text-lg" aria-hidden="true"></i>
      </a>
      <button
        type="button"
        onClick={goTop}
        aria-label="回到顶部"
        className="relative flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
      >
        <span
          className="pointer-events-none absolute inset-x-0 bottom-0 h-[3px] bg-accent-500"
          style={{ width: `${progress}%` }}
        ></span>
        <i className="ri-arrow-up-line text-lg" aria-hidden="true"></i>
      </button>
    </div>
  );
}